import { Injectable } from '@angular/core';

import { WebConstants } from '../util/web.constants';
import { Observable } from 'rxjs';
import { BaseResponse } from '../model/base.response';
import { AjaxHelper } from '../helper/ajax.helper';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CitationService {

  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper) { }

  getAll(): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.CITATION.FIND_ALL);
  }

  citationDataByPayloadID(payloadid: any): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.CITATION.CITATION_BY_ID + payloadid;
    return this.ajaxHelper.get(url);
  }

}
